import * as constants from "../../../../constants";

import { GetWeathersResult } from "./types";

import environments from "@/environments";

// 気象情報取得
export const getWeathers = (callback?: (res: GetWeathersResult) => void) => {
  const endpoint = `${environments.API_BASE_URI}/weathers`;

  return {
    type: constants.APP_CALL_API,
    endpoint: endpoint,
    method: "GET",
    callbacks: {
      begin: () => {
        return {
          type: constants.WEATHER_BEGIN_FETCH,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.WEATHER_END_FETCH,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};
